import Topbar from '../../itrust_common/components/authorised/layouts/Topbar.js';
import Sidebar from '../../components/authorised/layouts/Sidebar';
import OrganisationPaymentRoutes from './organisationPaymentRoutes.js';
import { connect } from 'react-redux';
import StoreSelection from '../../components/authorised/layouts/StoreSelection'
import EditExamModal from '../../components/authorised/buttons/EditExamModal'
import OrderModal from '../../components/authorised/buttons/OrderModal'
import CreateExamModal from '../../components/authorised/buttons/CreateExamModal'
import Alert from '../../itrust_common/components/Alert'
import QuickActionsWrap from '../../containers/authorised/dashboard/quickActions/QuickActionsWrap.js';
import RoutesRender from './RoutesRender.js';
import { useEffect } from 'react';

function Authorised(props) {
  const { layout, userType, currentUser, organisation, totalAmount, isTourActive, handleLogout, currentStoreId } = props

  useEffect(() => {
    if (currentUser.role == 'non_admin' && !localStorage.getItem('StoreID')) {
      Alert.warning("Please select Store from header in order to access moduleNames")
    }
  }, [currentStoreId])


  const getHeaderMenu = (role) => {
    if (role === "super_admin" || role === "itrust_admin") {
      return organisation.subscription_plan !== "enterprise" ? [
        { title: 'Manage Organization', icon: 'la-hospital-o', path: '/organisation/highlights' },
        { title: 'Preferences', icon: 'las la-cog' },
        { title: 'Your Billing', icon: 'la-dollar-sign', path: '/payment' },
        { title: 'Contact', icon: 'la-phone-square', path: '/settings/contact' }
      ] : [
        { title: 'Manage Organization', icon: 'la-hospital-o', path: '/organisation/highlights' },
        { title: 'Preferences', icon: 'las la-cog' },
        { title: 'Contact', icon: 'la-phone-square', path: '/settings/contact' }
      ]
    }
    else return [{ title: 'Contact', icon: 'la-phone-square', path: '/settings/contact' }, { title: 'Preferences', icon: 'las la-cog' }]
  }

  return (
    <>
      {["super_admin", "itrust_admin"].includes(currentUser.role) &&
        <div className={`${layout !== 'payment' && 'd-none'}`}>
          {OrganisationPaymentRoutes}
        </div>
      }
      <div className={`${layout !== 'default' && 'd-none'} ${currentUser.preferences?.accessibility?.quick_actions && 'quick-actions-wrapper'}`}>
        <Topbar
          userType={userType}
          headerMenu={currentUser && getHeaderMenu(currentUser.role)}
          handleLogout={handleLogout}
          storeSelectionComponent={<StoreSelection currentUser={currentUser} />}
        />
        <div className="main-div">
          <Sidebar organisation={organisation} totalAmount={totalAmount} key={organisation.add_ons_config?.type} isTourActive={isTourActive} />
          <div className="main-content position-relative px-5 bg-light quick-actions-space">
            {currentUser.preferences?.accessibility?.quick_actions && <QuickActionsWrap />}
            <RoutesRender currentUserRole={currentUser.role} />
            <EditExamModal />
            <OrderModal />
            <CreateExamModal />
          </div>
        </div>
      </div>
    </>
  )
}

const mapStateToProps = state => {
  const { other, auth, organisation, itrustPay, onBoarding: { isTourActive }, currentStore } = state;
  return {
    layout: other.layout,
    currentUser: auth.user,
    organisation: organisation.organisation,
    totalAmount: itrustPay.wallet_details.organisation_wallet_amount,
    isTourActive,
    currentStoreId: currentStore.store?.id
  }
}

export default connect(mapStateToProps)(Authorised);
